export const SEQUENCE_TAGS_TEXT = {
	loadingAria: 'Loading',
	showLess: 'Show less',
	/** @param {number} n */
	plus: (n) => `+${n}`,
	mirrorPlus: '+99',
};
